module.exports = __webpack_public_path__ + "static/media/lisa chen.42e3a750.svg";